import { readField, hasOwnProperty } from "../common/utils/objectUtilities";

export const propagateFields = (value, fields, onChange) => {
    fields.forEach(field => {
        if (typeof field === 'string' && hasOwnProperty(value, field)) {
            onChange(readField(value, field), field);
        } else if (typeof field !== 'string' && hasOwnProperty(value, field.dest)) {
            onChange(readField(value, field.dest), field.src);
        }
    });
}

export default propagateFields;
